import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { Input } from '@components/Input';
import Button from '@components/Button';
import { Typography } from '@components/Typography';
import { useThrottle, useCopyToClipboard, useTranslation } from '@hooks';
import { getSingleWidgetScript, getGridWidgetScript } from '@constants/widget';
import { ProductEvent } from '@constants/product-events';
import PostHogManager from '@widgets/posthog-manager';

const WidgetForm = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    '& button': {
        width: 'max-content',
    },
});

const Code = ({ widgetKey, type }) => {
    const { getValues } = useFormContext();
    const { t } = useTranslation();
    const { onCopy } = useCopyToClipboard();
    const [onCopyClick] = useThrottle(async value => {
        if (await onCopy(value)) {
            PostHogManager.capture(ProductEvent.WidgetCodeCopied, { widget_type: type });
        }
    }, 1000);

    const formattedValues = useMemo(() => {
        const { locations, brands, ...rest } = getValues();
        return {
            ...rest,
            locations: locations.map(item => item.id),
            brands: JSON.stringify(brands),
        };
    }, []);

    return (
        <WidgetForm>
            <Typography variant="caption" sx={{ marginBottom: '16px', color: 'var(--text-primary)' }}>
                {t('ShowcaseWidgets.addCodeSubtitle')}
            </Typography>
            <Input
                inputProps={{
                    value:
                        type === 'popup'
                            ? getSingleWidgetScript(widgetKey, formattedValues)
                            : getGridWidgetScript(widgetKey, formattedValues),
                }}
                label={null}
                fullWidth
                multiline
                minRows={3}
            />
            <Button
                type="submit"
                variant="outlined"
                onClick={() =>
                    type === 'popup'
                        ? onCopyClick(getSingleWidgetScript(widgetKey, formattedValues))
                        : onCopyClick(getGridWidgetScript(widgetKey, formattedValues))
                }
            >
                {t('buttons.copyCode')}
            </Button>
        </WidgetForm>
    );
};

export default Code;
